// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3GGtE","rootCenter":"LoadMoreObserver_rootCenter__3rpap","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3s4YN"};